import React from 'react';
import RouterCollection from './routes';
import "react-image-gallery/styles/css/image-gallery.css";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
   return (
      <div className="App">         
         <RouterCollection />
      </div>
   );
}

export default App;
